module.exports = __webpack_public_path__ + "static/media/dropbox.3d6abc13.png";